import React from 'react';
import ParticipationPreamble from './participationBreakdownParts/participationPreamble.js';
import ParticipationChart from './participationBreakdownParts/participationChart.js';
import { Box } from 'bloomer/lib/elements/Box';
import { Title } from 'bloomer/lib/elements/Title';
import { Section } from 'bloomer/lib/layout/Section';

export default function ParticipationBreakdown({
	startDate,
	endDate,
	averageDogsInOfficeEachDay,
	averageDogsInPlaygroupEachDay,
	officeParticipationData,
	playgroupParticipationData,
	colors
}) {
	return (
		<Box className="on-print-own-page" id="participation">
			<Title tag="h3">Activity Particiation:</Title>
			<Section>
				<ParticipationPreamble
					averagePerDay={averageDogsInOfficeEachDay}
					startDate={startDate}
					endDate={endDate}
					type="Office"
				/>
				<ParticipationChart
					participationData={officeParticipationData}
					colors={colors}
					type="office"
				/>
			</Section>
			<Section>
				<ParticipationPreamble
					averagePerDay={averageDogsInPlaygroupEachDay}
					startDate={startDate}
					endDate={endDate}
					type="Playgroup"
				/>
				<ParticipationChart
					participationData={playgroupParticipationData}
					colors={colors}
					type="playgroup"
				/>
			</Section>
		</Box>
	);
}
